import { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";

//Helper functions
import { getSettings, notifyError, notifySuccess, } from '../../../settings/Helpers';

//API
import api from '../../../settings/AxiosSetup';

//3rd party
import 'moment/locale/nl';
import moment from 'moment';
import 'moment-timezone';
import * as Icon from 'react-bootstrap-icons';
import { Chart as ChartJS, RadialLinearScale, ArcElement, Tooltip, Legend } from 'chart.js';
import { PolarArea } from 'react-chartjs-2';
import toast, { Toaster } from 'react-hot-toast';
import { exportToExcel } from 'react-json-to-excel';
import Skeleton from 'react-loading-skeleton';

//Components
import SideNav from '../../../components/sidenav/sidenav';
import BottomNav from '../../../components/bottomnav/bottomnav';
import DashboardHeader from '../../../components/dashboard/header';
import MyMapComponent from '../../../components/maps/googleMaps';

//Assets
import vsdvArtwork from '../../../assets/images/logo-detail.svg';
import svzArtwork from '../../../assets/images/artwork-svz.svg';

//styles
import './chauffeur.css';
import 'react-loading-skeleton/dist/skeleton.css';

const Chauffeur = () => {

    ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

    //Set variables
    const { id } = useParams();
    const environment = process.env.REACT_APP_APP_URL;
    const navigate = useNavigate();
    const loggedIn = localStorage.getItem('ingelogd');
    const medewerker = JSON.parse(localStorage.getItem('medewerker'));
    const [schades, setSchades] = useState([]);
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [
            {
            label: '',
            data: [],
            backgroundColor: [],
            borderWidth: 1,
            },
        ],
    });
    const [markers, setMarkers] = useState([]);
    const [chauffeur, setChauffeur] = useState('');
    const [chauffeurCommunicatie, setChauffeurCommunicatie] = useState([]);
    const scrollContainerRef = useRef(null);
    const [bericht, setBericht] = useState('');
    const [chatDatum, setChatDatum] = useState('');
    const [showFaded, setShowFaded] = useState(false);
    var odd_even = 'even';
    const offset = 120;

    const getChauffeurInfo = async () => {
        try {
            const response = await api.get('/schades/schades-chauffeur/' + id);
            if (response.data) {
                setSchades(response.data);
                setChauffeurCommunicatie(response.data[0].chauffeur_medewerker ? response.data[0].chauffeur_medewerker.communicatie : []);
                setChauffeur(response.data[0].chauffeur_medewerker.naam);
                var chartDataObj = {
                    labels: [],
                    datasets: [
                        {
                            label: 'Aantal schades',
                            data: [],
                            backgroundColor: []
                        }
                    ],
                    borderWidth: 1
                };
                const markersArray = [];
                response.data.map((item, index) =>  {
                    if (chartDataObj.labels.includes(item.schadetype.naam)) {
                        const arrayIndex = chartDataObj.labels.indexOf(item.schadetype.naam);
                        chartDataObj.datasets[0].data[arrayIndex]++;
                    } else {
                        chartDataObj.labels.push(item.schadetype.naam);
                        chartDataObj.datasets[0].data.push(1);
                        chartDataObj.datasets[0].backgroundColor.push(item.schadetype.kleur_grafiek);
                    }
                    const markerObj = { lat: Number(item.plaats.lat), lng: Number(item.plaats.lng) };
                    markersArray.push(markerObj);
                })
                setChartData(chartDataObj);
                setMarkers(markersArray)
            }
        } catch (error) {
            console.log(error);
        }
    }

    const downloadCsv = (data) => {
        var fileName = 'export-schades-' + chauffeur + '-' + moment().format('DD-MM-YYYY HH:mm');
        exportToExcel(data, fileName);
    }

    const exportSchadesChauffeur = async () => {
        console.log('/schades/schades/export/' + id);
            try {
                const response = await api.get('/schades/export/' + id);
                if (response.data) {
                    if (response.data.length === 0) {
                        return notifyError('Er zijn geen schades gevonden voor deze chauffeur')
                    }
                    downloadCsv(response.data);
                }
            } catch (error) {
                console.log(error);
            }
        }

    //Check if user is authenticated, else redirect to login
    useEffect(() => {
        //Get settings and check for maintenance
        const settings = getSettings();
        settings.then((result) => {
            if (result.onderhoudsmodus) {
                navigate('/onderhoud');
            }
        });
        if (loggedIn !== 'true') {
            navigate('/login');
        }
        getChauffeurInfo();
    }, []);

    useEffect(() => {
    if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
    }
    function handleScroll() {
        if (scrollContainerRef.current) {
            // Calculate the scroll difference from the bottom
            const scrollDifference = scrollContainerRef.current.scrollHeight - scrollContainerRef.current.scrollTop - scrollContainerRef.current.clientHeight;
    
            // Check if the scroll difference is more than 100px
            if (scrollDifference > 10) {
            setShowFaded(true);
            } else {
            setShowFaded(false);
            }

            const scrollPosition = scrollContainerRef.current.scrollTop;

            // Find the first message that is at or above the top of the visible area
            const chatMessages = scrollContainerRef.current.querySelectorAll('.message');
            let closestMessageDate = '';

            for (let i = 0; i < chatMessages.length; i++) {
            const message = chatMessages[i];
            const rect = message.getBoundingClientRect();

            if (rect.top <= scrollPosition + offset) {
                closestMessageDate = message.querySelector('.datetime').textContent;
            } else {
                break; // Stop checking once we find a message below the top of the visible area
            }
            }
            if (closestMessageDate) {
                setChatDatum(moment(closestMessageDate).format('DD-MM-YYYY'));
            }

        }
        }
    
        // Attach the scroll event listener to the scroll container
        scrollContainerRef.current?.addEventListener('scroll', handleScroll);
    
        // Clean up the event listener when the component unmounts
        return () => {
        scrollContainerRef.current?.removeEventListener('scroll', handleScroll);
        };
    }, [chauffeurCommunicatie]);

    const submitBericht = async (event) => {
        event.preventDefault();
        try {
            const response = await api.post('/medewerkers/bericht/' + id, {
                data: {
                    bericht: bericht,
                    sendMail: false
                }
            });
            if (response.data) {
                setChauffeurCommunicatie(response.data.communicatie);
                setBericht('');
            }
        } catch (error) {
            
        }
    }
    
    return (
    <div id="main" className="dashboard">
        {
            medewerker ?
            <SideNav page="/kenteken" />
            :
            null
        }
        
        <div className="dashboard-content">
            <DashboardHeader title={chauffeur ? chauffeur : 'Chauffeur'} />
            <div className="schade-content">
                <div className="column">
                    <div className="block">
                        <div className="block-header">
                            <h3>Overzicht schades</h3>
                        </div>
                        <div className="number-blocks">
                            {/* <div className="number-block">
                                <p className="number-block-title">Totaal schades</p>
                                <p className="number-block-value">{'Hier totaalbedrag'}</p>
                            </div> */}
                            <div className="number-block">
                                <p className="number-block-title">Aantal schades</p>
                                <p className="number-block-value">{schades.length}</p>
                            </div>
                        </div>
                    </div>
                    <div className="block">
                        <div className="block-header">
                            <h3>Lijst schades</h3>
                            <button onClick={() => exportSchadesChauffeur()} className="button green export-schades"><span>Exporteren</span><Icon.FileEarmarkSpreadsheet size={18} color={'#00d100'} /></button>
                        </div>
                        <div className="list-schades">
                            {
                                schades.map((item, index) =>  {
                                    return <div className="item">
                                        <p>{item.kenmerk}</p>
                                        <span style={{color:item.status.kleur}}>{item.status.naam}</span>
                                        <button onClick={() => navigate('/schades/' + item.id)} className="red-button button">Bekijken</button>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                    <div className="block">
                        <div className="block-header">
                            <h3>Op de kaart</h3>
                        </div>
                        {
                            markers.length > 0 ?
                            <MyMapComponent
                                defaultZoom={markers.length > 1 ? 7 : 8} 
                                isMarkerShown 
                                lat={markers.length > 1 ? 52.092876 : markers[0].lat} 
                                lng={markers.length > 1 ? 5.104480 : markers[0].lng}
                                markers={markers}
                            />
                            :
                            null
                        }
                    </div>
                    <div className="block">
                        <h3>Communicatie</h3>
                        {
                        chauffeurCommunicatie ?
                        <div className="chatbox">
                        <div className={'faded-chat ' + (showFaded ? '' : 'hide')}>
                            <span>{chatDatum}</span>
                        </div>
                        {
                            chauffeurCommunicatie.length > 0 ?
                            <div className="chat" ref={scrollContainerRef}>
                                {
                                    chauffeurCommunicatie.map((item, index) =>  {
                                        if (index > 0) {
                                            if (item.door === chauffeurCommunicatie[index - 1].door) {} else {
                                                if (odd_even === 'even') {
                                                    odd_even = 'odd';
                                                } else {
                                                    odd_even = 'even';
                                                }
                                            }
                                        }
                                        return <div key={index} className={'message ' + odd_even}>
                                            <div className="message-content">
                                                <div className="message-header">
                                                    <span>{item.door}</span>
                                                    <span className="date">
                                                        {
                                                            item.mail_verstuurd ?
                                                            <>
                                                            <span className="mail" id={'mail-send-' + index}><Icon.EnvelopeCheckFill color="#CB0A32" /></span>
                                                            <Tooltip
                                                                anchorId={'mail-send-' + index}
                                                                place="bottom"
                                                                content="Mail van opmerking verstuurd"
                                                            />
                                                            </>
                                                            :
                                                            null
                                                        }
                                                        {moment(item.datum_tijd).format('DD-MM-YYYY HH:mm')}
                                                    </span>
                                                    <span className="datetime">{item.datum_tijd}</span>
                                                </div>
                                                <span className="contents">{item.bericht}</span>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                            :
                            <p>Er zijn nog geen opmerkingen geplaatst</p>
                        }
                        </div>
                        :
                        <>
                        <Skeleton height={20} style={{marginBottom:10}} />
                        <Skeleton height={20} style={{marginBottom:10}} />
                        <Skeleton height={20} style={{marginBottom:10}} />
                        <Skeleton height={20} style={{marginBottom:10}} />
                        </>
                    }
                    <form id="add-log" onSubmit={submitBericht}>
                        <textarea placeholder="Schrijf bericht" value={bericht} onChange={(e) => setBericht(e.target.value)} required></textarea>
                        <input type="submit" value="Verstuur" className="button" />
                    </form>
                    </div>
                </div>
                <div className="column">
                    <div className="chart">
                        <PolarArea data={chartData} />
                    </div>
                </div>
            </div>
            <Toaster />
        </div>
        {
            medewerker ?
            <BottomNav page="/kenteken" />
            :
            null
        }
    <img src={svzArtwork} className="artwork" />    
    </div>
    );
};
export default Chauffeur;